import { render, staticRenderFns } from "./cardBtn.vue?vue&type=template&id=2e12bd4c&scoped=true&"
import script from "./cardBtn.ts?vue&type=script&lang=ts&"
export * from "./cardBtn.ts?vue&type=script&lang=ts&"
import style0 from "./cardBtn.vue?vue&type=style&index=0&id=2e12bd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12bd4c",
  null
  
)

export default component.exports